import SidebarItem from './SidebarItem.jsx';
import NavItem from './NavItem.jsx';
import { getMenuIcon } from './menuIcons.js';

function sanitizeId(label) {
  return label.toLowerCase().replace(/[^a-z0-9]+/g, '-');
}

export default function SidebarSection({
  iconKey,
  label,
  labelContent,
  items,
  isOpen,
  onToggle,
  isCollapsed,
  isActive,
  module,
  itemLabelContent,
  activeItemRef,
}) {
  const sectionId = `sidebar-section-${module}-${sanitizeId(label)}`;
  const Icon = getMenuIcon(iconKey);

  return (
    <NavItem
      icon={Icon}
      label={label}
      labelContent={labelContent}
      active={isActive}
      collapsed={isCollapsed}
      open={isOpen}
      onToggle={onToggle}
      submenuId={sectionId}
    >
      {items.map((item, index) => {
        const category = getCategory(label, item);
        const previousCategory = index ? getCategory(label, items[index - 1]) : null;
        return (
          <div key={item.to}>
            {category && category !== previousCategory ? (
              <div className="sidebar-subsection-label" role="presentation">{category}</div>
            ) : null}
            <SidebarItem
              iconKey={item.iconKey ?? 'default'}
              label={item.label}
              labelContent={itemLabelContent?.(item.label)}
              to={item.to}
              isCollapsed={isCollapsed}
              isSubItem
              elementRef={activeItemRef?.(item)}
            />
          </div>
        );
      })}
    </NavItem>
  );
}

function getCategory(sectionLabel, item) {
  if (sectionLabel.includes('Empresa')) {
    return item.to.includes('/empresa/') && !item.to.includes('plantilla') && !item.to.includes('correo') && !item.to.includes('comprobantes') && !item.to.includes('puntos-de-venta') && !item.to.includes('numeracion')
      || item.to.includes('/redespachos')
      ? 'Estructura'
      : 'Documentación';
  }

  if (sectionLabel.includes('AFIP')) {
    if (item.to.includes('padron')) return 'Padrones';
    if (item.to.includes('percepc')) return 'Percepciones';
    if (item.to.includes('certificados')) return 'Certificados y factura electrónica';
    return 'Documentación fiscal';
  }

  return null;
}
